module.exports = __webpack_public_path__ + "static/media/DairyNZ-logo-trans.97ad5de1.png";